module.exports = __webpack_public_path__ + "media/images/other-images/maintenance-bg-174c05be80e1ac4eab0eeb76edb7cff7.jpg";